import { arrayMove } from "@dnd-kit/sortable";
import { Collapse } from "antd";
import { useEffect } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import CustomInputRadioField from "../../../components/Common/customInputRadioField";
import { UploadImage } from "../../../components/Common/customUploadField";
import InputNumberField from "../../../components/Common/inputNumberField";
import InputTextField from "../../../components/Common/inputTextField";
import MultiSelectField from "../../../components/Common/Select/multiSelectField";
import SelectField from "../../../components/Common/Select/selectField";
import {
  action,
  MedicineStatus,
  prescriptionType,
  returnable,
  yesOrNo,
} from "../../../components/Constants";

const { Panel } = Collapse;

const StepOne = ({
  register,
  errors,
  setValue,
  control,
  watch,
  trigger,
  fileList,
  setFileList,
  getValues,
  manufacturerList = [],
  unitList = [],
  saltList = [],
  medicineTypes = [],
  variants,
  setVariants,
}) => {
  watch("manufacturer");
  watch("salt_molecule");
  const manufacturerDetails = getValues("manufacturer");
  const saltDetails = getValues("salt_molecule");
  const mrp = watch("mrp");
  const quantity = watch("quantity");

  // const addVariant = () => {
  //   const value = variants.length ? variants[variants.length - 1]?.id + 1 : 1;
  //   setVariants([
  //     ...variants,
  //     { title: `Variant ${value}`, id: value, images: [] },
  //   ]);
  // };

  // const handleDelete = (indexToDelete) => {
  //   setVariants((prevVariants) =>
  //     prevVariants.filter((_, index) => index !== indexToDelete)
  //   );
  // };

  const onChangeImages = (newFileList) => {
    setFileList(newFileList);
  };

  const onRemoveImages = (file) => {
    setFileList((prevList) => prevList.filter((item) => item.uid !== file.uid));
  };

  const onDragEndImages = (active, over) => {
    setFileList((items) => {
      const oldIndex = items.findIndex((file) => file.uid === active.id);
      const newIndex = items.findIndex((file) => file.uid === over.id);
      return arrayMove(items, oldIndex, newIndex);
    });
  };

  // const onChangeVariant = (newFileList, title) => {
  //   setVariants((pre) =>
  //     pre.map((data) => {
  //       if (data.title === title) {
  //         return { ...data, images: newFileList };
  //       } else {
  //         return data;
  //       }
  //     })
  //   );
  // };

  // const onRemoveVariant = (file, title) => {
  //   setVariants((pre) =>
  //     pre.map((data) => {
  //       if (data.title === title) {
  //         return {
  //           ...data,
  //           images: data.images.filter((item) => item.uid !== file.uid),
  //         };
  //       } else {
  //         return data;
  //       }
  //     })
  //   );
  // };

  // const onDragEndVariant = (active, over, title) => {
  //   setFileList((items) => {
  //     const oldIndex = items.findIndex((file) => file.uid === active.id);
  //     const newIndex = items.findIndex((file) => file.uid === over.id);
  //     return arrayMove(items, oldIndex, newIndex);
  //   });

  //   setVariants((pre) =>
  //     pre.map((data) => {
  //       if (data.title === title) {
  //         const oldIndex = data.images.findIndex(
  //           (file) => file.uid === active.id
  //         );
  //         const newIndex = data.images.findIndex(
  //           (file) => file.uid === over.id
  //         );
  //         return {
  //           ...data,
  //           images: arrayMove(data.images, oldIndex, newIndex),
  //         };
  //       } else {
  //         return data;
  //       }
  //     })
  //   );
  // };

  useEffect(() => {
    const mrpValue = parseFloat(mrp);
    const quantityValue = parseFloat(quantity);

    if (!isNaN(mrpValue) && !isNaN(quantityValue) && quantityValue > 0) {
      const result = (mrpValue / quantityValue).toFixed(2);
      setValue("mrp_per_unit", result);
    } else {
      setValue("mrp_per_unit", "");
    }
  }, [mrp, quantity, setValue]);

  return (
    <>
      <div className="medicinesListWrapper">
        <div className="text-center medicineUploadFile">
          <UploadImage
            fileList={fileList}
            setFileList={setFileList}
            onChangeImages={onChangeImages}
            onRemoveImages={onRemoveImages}
            onDragEndImages={onDragEndImages}
            name={"images"}
          />
        </div>
        <div className="row car-dep-form m-0 p-0 mb-4">
          <div className="col-md-6 ">
            <InputTextField
              id="medicine name"
              register={register}
              labelName="Medicine Name"
              errorText="Please enter the Medicine Name"
              errors={errors}
              name="medicine_name"
              placeholder="Type here..."
              className="w-100 customFields"
            />
          </div>
          <div className="col-md-6">
            <InputTextField
              id="package Description"
              register={register}
              labelName="Package Description"
              errorText="Please enter the Package Description"
              errors={errors}
              className="customFields w-100"
              name="package_description"
              placeholder="Type here..."
            />
          </div>
        </div>
        <div className="row car-dep-form m-0 p-0 mb-4">
          <div className="col-md-6">
            <InputTextField
              id="Product id"
              register={register}
              labelName="Product ID"
              errorText="Please enter the Product id"
              errors={errors}
              className="customFields w-100"
              name="product_id"
              placeholder="Type here..."
              type="number"
            />
          </div>
          <div className="col-md-6">
            <SelectField
              getValues={getValues}
              labelName="Medicine Type"
              name="medicine_type"
              options={medicineTypes}
              register={register}
              errors={errors}
              errorText="Please select the Medicine Type"
              className="customSelectField customFields w-100"
              isOptionObject={true}
            />
          </div>
        </div>
        <div className="row car-dep-form m-0 p-0 mb-4">
          <div className="col-md-6 pe-2">
            <SelectField
              getValues={getValues}
              labelName="Medicine Status"
              name="medicine_status"
              options={MedicineStatus}
              errors={errors}
              errorText="Please choose a Medicine Status"
              className="customFields w-100"
              register={register}
              trigger={trigger}
              watch={watch}
              setValue={setValue}
            />
          </div>
          <div className="col-md-6 ps-3">
            <CustomInputRadioField
              labelName="Prescription Type"
              name="prescription_type"
              options={prescriptionType}
              errors={errors}
              errorText="Please choose a Prescription Type"
              className="customSelectField customFields w-100"
              register={register}
              trigger={trigger}
              watch={watch}
              setValue={setValue}
            />
          </div>
        </div>
        <div className="col-md-4">
          <CustomInputRadioField
            name="medicine_url_status"
            labelName="Medicine URL Status"
            options={action}
            errors={errors}
            errorText="Please choose a Medicine Status"
            register={register}
            trigger={trigger}
            watch={watch}
            setValue={setValue}
          />
        </div>
      </div>
      <Collapse
        expandIconPosition={"end"}
        expandIcon={({ isActive }) =>
          isActive ? <IoIosArrowUp size={22} /> : <IoIosArrowDown size={22} />
        }
      >
        <Panel
          header={
            <div className="d-flex align-items-center justify-content-between">
              <span className="fs18fwb">Manufacturer Details</span>
            </div>
          }
        >
          <div className="manufacturer-details-section addnew-form1-autor-detail mt-2 d-flex gap-4">
            <div className="col-md-6 pe-2">
              <MultiSelectField
                name="manufacturer"
                labelName="Select Manufacturer"
                control={control}
                errors={errors}
                options={manufacturerList}
                isMulti={false}
                placeholder="Select"
                requiredText="Please select the Select Manufacturer"
              />
            </div>
            <div className="col-md-6 ps-3">
              <InputTextField
                labelName="Manufacturer Address"
                isReadOnly={true}
                inputValue={manufacturerDetails?.manufacturer_address}
                className="customFields inputTextField w-100"
              />
            </div>
          </div>
          <div className="manufacturer-details-section addnew-form1-autor-detail mt-4 d-flex gap-4">
            <div className="col-md-6 pe-2">
              <InputTextField
                labelName="Country of Origin"
                isReadOnly={true}
                inputValue={manufacturerDetails?.country_of_origin}
                className="customFields inputTextField w-100 "
              />
            </div>
            <div className="col-md-6 ps-3">
              <InputTextField
                labelName="Customer Care Email"
                isReadOnly={true}
                inputValue={manufacturerDetails?.customer_email}
                className="customFields inputTextField w-100 "
              />
            </div>
          </div>
        </Panel>
      </Collapse>
      <Collapse
        expandIconPosition={"end"}
        expandIcon={({ isActive }) =>
          isActive ? <IoIosArrowUp size={22} /> : <IoIosArrowDown size={22} />
        }
      >
        <Panel
          header={
            <div className="d-flex align-items-center justify-content-between">
              <span className="fs18fwb">MRP & Other details</span>
            </div>
          }
        >
          <div className="manufacturer-details-section addnew-form1-autor-detail mt-2 d-flex">
            <div className="col-md-4 pe-3">
              <InputNumberField
                register={register}
                labelName="MRP"
                errorText="Please enter the MRP"
                errors={errors}
                name="mrp"
                min={0}
                placeholder="Type here"
                className="customFields w-100"
              />
            </div>
            <div className="col-md-4 px-2">
              <InputNumberField
                register={register}
                labelName="Discount (%)"
                errorText="Please enter the Discount"
                errors={errors}
                name="discount"
                min={0}
                max={100}
                maxLength={3}
                placeholder="Type here"
                className="customFields w-100"
              />
            </div>
            <div className="col-md-4 ps-3">
              <InputNumberField
                register={register}
                labelName="Quantity"
                errorText="Please enter the Quantity"
                errors={errors}
                min={0}
                name="quantity"
                placeholder="Type here"
                className="customFields w-100"
              />
            </div>
          </div>
          <div className="manufacturer-details-section addnew-form1-autor-detail mt-4 d-flex">
            <div className="col-md-4  pe-3">
              <InputNumberField
                register={register}
                labelName="MRP Per Unit"
                errorText="Please enter the MRP Per Unit"
                errors={errors}
                name="mrp_per_unit"
                placeholder="Type here"
                className=" customFields w-100"
                min={0}
                disable={true}
              />
            </div>
            <div className="col-md-4 px-2">
              <SelectField
                getValues={getValues}
                labelName="Unit"
                name="unit"
                register={register}
                isOptionObject={true}
                options={unitList}
                errors={errors}
                className="customSelectField customFields w-100"
                errorText="Please select the Unit"
              />
            </div>
            <div className="col-md-4 ps-3">
              <CustomInputRadioField
                name="returnable"
                labelName="Returnable"
                options={returnable}
                errors={errors}
                errorText="Please choose a returnable"
                register={register}
                trigger={trigger}
                watch={watch}
                setValue={setValue}
              />
            </div>
          </div>
          <div className="manufacturer-details-section addnew-form1-autor-detail mt-2 d-flex gap-4">
            <div className="col-md-4">
              <CustomInputRadioField
                name="open_box"
                labelName="Open Box"
                options={yesOrNo}
                errors={errors}
                errorText="Please choose a Open Box"
                register={register}
                trigger={trigger}
                watch={watch}
                setValue={setValue}
              />
            </div>
          </div>
        </Panel>
      </Collapse>
      <Collapse
        expandIconPosition={"end"}
        expandIcon={({ isActive }) =>
          isActive ? <IoIosArrowUp size={22} /> : <IoIosArrowDown size={22} />
        }
      >
        <Panel
          header={
            <div className="d-flex align-items-center justify-content-between">
              <span className="fs18fwb">Molecule & Other details</span>
            </div>
          }
        >
          <div className="manufacturer-details-section addnew-form1-autor-detail mt-2 d-flex gap-4">
            <div className="d-flex w-100">
              <div className="col-md-6 pe-2">
                <MultiSelectField
                  name="salt_molecule"
                  labelName="Salt/Molecule"
                  control={control}
                  errors={errors}
                  options={saltList}
                  isMulti={false}
                  isSearchable={false}
                  placeholder="Select"
                  errorText="Please select the Salt/Molecule"
                />
              </div>
              <div className="col-md-6 ps-3">
                <InputTextField
                  labelName="Therapeutic Classification"
                  isReadOnly={true}
                  inputValue={saltDetails?.therapeutic_classification}
                  className="customFields inputTextField w-100"
                />
              </div>
            </div>
          </div>
          <div className="col-md-5 mt-4 w-100">
            <InputTextField
              id="therapeutic_uses"
              register={register}
              labelName="Therapeutic Uses"
              errorText="Please enter the Therapeutic Uses"
              errors={errors}
              name="therapeutic_uses"
              placeholder="Type here"
              className="customFields w-100"
            />
          </div>
        </Panel>
      </Collapse>
      {/* <div>
          {variants.map((variant, index) => (
            <Fragment key={index}>
              <div className="mt-5 d-flex justify-content-between mb-4">
                <div className="fs18fwb">Variant {index + 1}</div>
                <div className="medicineDeleteBtn gap-2 d-flex align-items-center">
                  <Popconfirm
                    title="Are you sure you want to delete this variant?"
                    onConfirm={() => handleDelete(index)}
                    okText="Delete"
                    cancelText="Cancel"
                  >
                    <div className="bg-danger  d-flex align-items-center gap-2">
                      <img
                        src={deleteIcon}
                        className="cursor-pointer"
                        alt="deleteIcon"
                      />
                      <Button className="bg-danger text-white border-0 p-0">
                        Delete
                      </Button>
                    </div>
                  </Popconfirm>
                </div>
              </div>
              <UploadImage
                fileList={variant.images}
                setFileList={setFileList}
                onChangeImages={onChangeVariant}
                onRemoveImages={onRemoveVariant}
                onDragEndImages={onDragEndVariant}
                name={variant.title}
              />
              <div className="pt-4">
                <div className="row car-dep-form m-0">
                  <div className="col-md-8 pe-2">
                    <InputTextField
                      id="package Description"
                      register={register}
                      labelName="Package Description"
                      errorText="Please enter the Package Description"
                      errors={errors}
                      className="customFields w-100"
                      name={`package_description-${variant.id}`}
                      placeholder="Type here..."
                    />
                  </div>
                  <div className="col-md-4 pe-3">
                    <InputNumberField
                      register={register}
                      labelName="MRP"
                      errorText="Please enter the MRP"
                      errors={errors}
                      name={`mrp-${variant.id}`}
                      min={0}
                      placeholder="Type here"
                      className="customFields w-100"
                    />
                  </div>
                  <div className="col-md-4 px-2  mt-4">
                    <InputNumberField
                      register={register}
                      labelName="Discount (%)"
                      errorText="Please enter the Discount"
                      errors={errors}
                      name={`discount-${variant.id}`}
                      min={0}
                      max={100}
                      maxLength={3}
                      placeholder="Type here"
                      className="customFields w-100"
                    />
                  </div>
                  <div className="col-md-4 ps-3  mt-4">
                    <InputNumberField
                      register={register}
                      labelName="Quantity"
                      errorText="Please enter the Quantity"
                      errors={errors}
                      min={0}
                      name={`quantity-${variant.id}`}
                      placeholder="Type here"
                      className="customFields w-100"
                    />
                  </div>
                  <div className="col-md-4 mt-4">
                    <InputNumberField
                      register={register}
                      labelName="MRP Per Unit"
                      errorText="Please enter the MRP Per Unit"
                      errors={errors}
                      name={`mrp_per_unit-${variant.id}`}
                      placeholder="Type here"
                      className=" customFields w-100"
                      min={0}
                    />
                  </div>
                  <div className="col-md-4 mt-4">
                              <SelectField
            getValues={getValues}
                      labelName="Unit"
                      name={`unit-${variant.id}`}
                      register={register}
                      isOptionObject={true}
                      options={unitList}
                      errors={errors}
                      className="customSelectField customFields w-100"
                      errorText="Please select the Unit"
                    />
                  </div>
                  <div className="col-md-4 mt-4">
                    <CustomInputRadioField
                      name={`stock-${variant.id}`}
                      labelName="Stock"
                      options={stock}
                      errors={errors}
                      errorText="Please choose a stock"
                      register={register}
                      trigger={trigger}
                      watch={watch}
                      setValue={setValue}
                    />
                  </div>
                  <div className="col-md-4 mt-4">
                    <CustomInputRadioField
                      name={`prescription_type-${variant.id}`}
                      labelName="Prescription Type"
                      options={prescriptionType}
                      errors={errors}
                      errorText="Please choose a Prescription Type"
                      register={register}
                      trigger={trigger}
                      watch={watch}
                      setValue={setValue}
                    />
                  </div>
                  <div className="col-md-4 mt-4">
                    <CustomInputRadioField
                      name={`medicine_status-${variant.id}`}
                      labelName="Medicine Status"
                      options={action}
                      errors={errors}
                      errorText="Please choose a Medicine Status"
                      register={register}
                      trigger={trigger}
                      watch={watch}
                      setValue={setValue}
                    />
                  </div>
                  <div className="col-md-4 ps-3  mt-4">
                    <CustomInputRadioField
                      name={`returnable-${variant.id}`}
                      labelName="Returnable"
                      options={returnable}
                      errors={errors}
                      errorText="Please choose a returnable"
                      register={register}
                      trigger={trigger}
                      watch={watch}
                      setValue={setValue}
                    />
                  </div>
                  <div className="col-md-4  mt-4">
                    <CustomInputRadioField
                      name={`open_box-${variant.id}`}
                      labelName="Open Box"
                      options={yesOrNo}
                      errors={errors}
                      errorText="Please choose a Open Box"
                      register={register}
                      trigger={trigger}
                      watch={watch}
                      setValue={setValue}
                    />
                  </div>
                </div>
              </div>
            </Fragment>
          ))}
          <button
            onClick={addVariant}
            className="bg-none mt-4 medicineAddVariants fs16fwb"
          >
            <img src={addIcon} className="me-2" alt="add-icon" /> Add New Variants
          </button>
        </div> */}
    </>
  );
};

export default StepOne;
